import { Component, input } from '@angular/core';
import { ZiroLink } from '../../models/ziro-link';
import { ZiroIcons } from '../../models/ziro-icons.enum';

@Component({
  selector: 'ziro-base-container',
  templateUrl: './base-container.component.html',
  styleUrls: ['./base-container.component.scss'],
  standalone: false,
})
export class BaseContainerComponent {
  window = window;
  readonly pageDisabled = input<boolean>();
  readonly serverDisabled = input<boolean>();
  readonly pageDisabledMessage = input<string>();
  readonly links = input<ZiroLink[]>();
  readonly licenseExpired = input<boolean>();
  readonly isDialPlansConfigured = input<boolean>();
  readonly isProxyServer = input<boolean>();
  readonly isProxyKeyConfigured = input<boolean>();

  ziroIcons = ZiroIcons;
  disableLink = ['admin/site-management', 'admin/cisco/dial-plan-management', 'phone-button-templates'];
  dialPlanLinkPatterns = [
    /^tenants\/\d+\/dial-plan-inventory$/,
    /^\/automations\/tenants\/\d+\/zero-touch-provisioning$/,
    /^\/automations\/tenants\/\d+\/bulk-provisioning$/,
  ];

  disableLinks(link: ZiroLink): boolean {
    if (link.isDisabled) {
      return true;
    } else if (this.licenseExpired() && !this.isProxyServer()) {
      return true;
    } else if (!this.isDialPlansConfigured() && this.isDialPlanLink(link?.url)) {
      return true;
    } else if (this.disableLink.includes(link.url)) {
      return this.serverDisabled();
    } else if (!this.isProxyKeyConfigured() && link.url === '/admin/proxy-server-management/proxy-feature-settings') {
      return true;
    }
    return false;
  }

  getDisableTooltip(link?: ZiroLink): string {
    if (link?.isDisabled) {
      return 'tkey;reports.side_nav.disabled_server.tooltip';
    } else if (this.licenseExpired() && !this.isProxyServer()) {
      return 'tkey;admin.menu.license_expired.tooltip';
    } else if (!this.isDialPlansConfigured() && this.isDialPlanLink(link?.url)) {
      return 'tkey;global.zpm.no_dial_plans.text';
    } else if (!this.isProxyKeyConfigured() && link?.url === '/admin/proxy-server-management/proxy-feature-settings') {
      return 'tkey;admin.menu.proxy_key_unconfigured.tooltip.zpc';
    } else {
      return 'tkey;admin.servers.disable.tooltip';
    }
  }

  private isDialPlanLink(url: string): boolean {
    if (!url) {
      return false;
    }
    return this.dialPlanLinkPatterns.some((pattern) => pattern.test(url));
  }
}
